// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Draft } from "immer";

type OrderDetailsTotalState = ApplicationState["bunzl"]["components"]["orderDetailsTotal"];

const initialState: OrderDetailsTotalState = {
    hidePriceOnPrint: false,
};

const actions = {
    "Store/Components/OrderDetailsTotal/SetPrintOption": (
        draft: Draft<OrderDetailsTotalState>,
        action: { parameter: OrderDetailsTotalState },
    ) => {
        draft.hidePriceOnPrint = action.parameter.hidePriceOnPrint ?? false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlComponentsOrderDetailsTotalActions = BunzlActionUnion<typeof actions>;
export default reducer;
